import React, { useEffect, useState } from "react";
import { MdDelete } from "react-icons/md";
import { toast } from "react-toastify";
import _ from "lodash";
import ButtonImagePermission from "../../Button/ButtonImagePermission";
import useApiClient from "../../../../hooks/apiClient";
import EfisModal from "../../EfisModal/EfisModal";

const deleteCell = (item, description, permissionDelete, setShowExcluirConfirm) => (
  <ButtonImagePermission
    permission={permissionDelete}
    className="btn-lg text-danger pa-0 p-0"
    onClick={() => {
      setShowExcluirConfirm({
        show: true,
        body: `Deseja excluir a ocorrência Nº "${description}"?`,
        context: item,
      });
    }}
    buttonImage={<MdDelete />}
    tooltipImage="Excluir"
  />
);

const useDeleteItemOcorrencia = ({
  columns,
  deleteService,
  keyField,
  descriptionField,
  permissionDelete,
  onDeleteItem,
}) => {
  const [showExcluirConfirm, setShowExcluirConfirm] = useState({
    show: false,
    body: null,
    context: null,
  });

  if (deleteService) {
    if (_.last(columns).name === "Ações") {
      columns.pop();
    }

    columns.push({
      name: "Ações",
      center: true,
      maxWidth: "1%",
      cell: (row) => deleteCell(row, row[descriptionField], permissionDelete, setShowExcluirConfirm),
    });
  }

  const { request, data, errors, isLoading } = useApiClient();

  useEffect(() => {
    if (!data && !errors) return;

    if (data) {
      toast.success("Item excluído com sucesso. ");
      if (typeof onDeleteItem === "function") {
        onDeleteItem();
      }
    }

    if (errors) {
      toast.error(errors.message ?? "Erro durante a exclusão. ");
    }

    setShowExcluirConfirm({ show: false });
  }, [data, errors, onDeleteItem, setShowExcluirConfirm]);

  const excluirConfirmModal = (
    <EfisModal
      show={showExcluirConfirm.show}
      body={showExcluirConfirm.body}
      loadingConfirmationAction={isLoading}
      closeHandler={() => setShowExcluirConfirm({ show: false })}
      confirmationHandler={() => {
        request(deleteService, { [keyField]: showExcluirConfirm.context[keyField] });
      }}
    />
  );

  return { excluirConfirmModal };
};

export default useDeleteItemOcorrencia;
